export const FETCH_EMPLOYMENTS_REQUEST = 'FETCH_EMPLOYMENTS_REQUEST'
export const FETCH_EMPLOYMENTS_SUCCES = 'FETCH_EMPLOYMENTS_SUCCES'
export const FETCH_EMPLOYMENTS_ERROR = 'FETCH_EMPLOYMENTS_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Employments.js